import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { useLang, useSeo } from '@/i18n/LanguageContext';
import PageHero from '@/components/PageHero';
import { Reveal } from '@/components/Reveal';

export default function Faq() {
  const { content } = useLang();
  useSeo(`${content.faq.title} | Rodotrack`, content.faq.subtitle);
  const c = content.faq;

  return (
    <>
      <PageHero badge={c.eyebrow} title={c.title} subtitle={c.subtitle} />
      <section className="py-16 lg:py-24" data-testid="faq-section">
        <div className="container-x max-w-3xl">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-3">
              {c.items.map((item, i) => (
                <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="rounded-2xl border border-brand-line bg-white px-6">
                  <AccordionTrigger className="py-5 text-left font-display text-[16px] font-bold text-brand-navy hover:text-brand-blue hover:no-underline">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-[14.5px] leading-relaxed text-brand-muted">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>
    </>
  );
}